import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { API } from "../lib/api";
import { Logo } from "../components/shared";
import { Card } from "../components/ui/card";
import ReportForm from "../components/ReportForm";

export default function QRReport() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    axios.get(`${API}/public/site/${token}`).then((r) => setInfo(r.data)).catch(() => setError(true));
  }, [token]);

  const submit = async (payload) => {
    await axios.post(`${API}/public/reports`, { ...payload, site_id: info.site.id, org_id: info.organization.id });
    toast.success("Report submitted");
  };

  if (error)
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-background p-6 text-center">
        <Logo />
        <p className="mt-6 text-muted-foreground">This QR code is invalid or has expired.</p>
      </div>
    );

  if (!info)
    return <div className="flex min-h-screen items-center justify-center bg-background"><Loader2 className="h-6 w-6 animate-spin text-[hsl(var(--accent))]" /></div>;

  return (
    <div className="min-h-screen bg-secondary/40">
      <header className="sticky top-0 z-10 border-b border-border bg-background/80 backdrop-blur-xl">
        <div className="mx-auto flex max-w-lg items-center justify-between px-4 py-3">
          <Logo />
        </div>
      </header>
      <div className="mx-auto max-w-lg px-4 py-6">
        <div className="mb-5">
          <div className="text-xs font-semibold uppercase tracking-[0.16em] text-[hsl(var(--accent))]">{info.organization?.name}</div>
          <h1 className="mt-1 font-heading text-2xl font-bold tracking-tight">{info.site.name}</h1>
          <p className="text-sm text-muted-foreground">{info.site.location}</p>
        </div>
        <Card className="rounded-2xl border-border p-5 sm:p-6">
          <ReportForm categories={info.categories} sites={[info.site]} requireName onSubmit={submit} />
        </Card>
        <p className="mt-6 text-center text-xs text-muted-foreground">No login required · Reports are confidential</p>
      </div>
    </div>
  );
}
